import {
    SHOW_TOAST_WITH_PROPS,
    HIDE_TOAST
} from '../../containers/SpockViewPage/actions/actionConstants';


const initialState = {
    message:"",
    type:"",
    delayTime:null,
    show:false,
    entityType: "",
    cId: 0,
    actId: 0,
    showActions: true,
    isCloseIcon:false,
    autoClose:true,
    iconType:""
};

export default function toast(state=initialState, action){
    switch(action.type){
        case SHOW_TOAST_WITH_PROPS:
            return Object.assign (
                {},
                state,
                {
                    message:action.payload.message,
                    type:action.payload.type,
                    delayTime:action.payload.delayTime,
                    show:true,
                    iconType:action.payload.iconType,
                    entityType: action.payload.entityType,
                    cId: action.payload.cId,
                    actId: action.payload.actId,
                    showActions: action.payload.showActions,
                    isCloseIcon:action.payload.isCloseIcon || initialState.isCloseIcon,
                    autoClose:!action.payload.autoClose ? action.payload.autoClose :  initialState.autoClose
                }
            );
        case HIDE_TOAST :
            return initialState;

        default :
            return state;
    }
}